import { DialogProps } from "@mui/material/Dialog";
import { Dialog as StyledDialog } from "./styles";
import React from "react";

export type Props = DialogProps & React.PropsWithChildren<unknown>;

export function Dialog(props: Props) {
  return <StyledDialog {...props} />;
}
